import { Client, Databases, Account, Query, Functions } from 'appwrite';

export const client = new Client();

// Endpoint + project are environment-specific (prod = FRA, staging = SFO) and
// REQUIRED - no prod fallback, so a misconfigured build fails loudly instead of
// silently talking to production. Set VUE_APP_APPWRITE_ENDPOINT and
// VUE_APP_APPWRITE_PROJECT in every Vercel project (and .env.local for dev).
// All database/collection/function IDs below are identical across environments
// (pinned in Terraform), so they need no per-env override.
const APPWRITE_ENDPOINT = process.env.VUE_APP_APPWRITE_ENDPOINT;
const APPWRITE_PROJECT = process.env.VUE_APP_APPWRITE_PROJECT;
if (!APPWRITE_ENDPOINT || !APPWRITE_PROJECT) {
    throw new Error(
        'Missing Appwrite config: set VUE_APP_APPWRITE_ENDPOINT and VUE_APP_APPWRITE_PROJECT'
    );
}

client
    .setEndpoint(APPWRITE_ENDPOINT)
    .setProject(APPWRITE_PROJECT);

export const account = new Account(client);
export const databases = new Databases(client);
export const query = Query;
export const functions = new Functions(client);

export const appwriteConfig = {
    database: '66d378140001446d6b1a',
    collections: {
        settings: '66d3782a0011430b8ff2',
        legs: '66d3782200380f9d6f56',
        syncs: '66e738940034eed2d7d3',
        checkrides: '68518bab002f78217fff'
    },
    functions: {
        getUserLabels: '66d38b3b001951f842d4',
        setUserLabel: '66d38b6900007a304bd9',
        deleteUser: '66e5df2a000ed2110fd9',
        syncLegs: '66e73d9c000f5fd22df8',
        completeLeg: '67141964002c5d1f5f0c',
        fetchTailNumbers: '68183433002332238e0c',
        fetchLegs: '681838bd002eb7304981',
        fetchCheckAirmen: '68197af5001cf39dbae7',
        fetchPilots: '689aba66002899017ff8',
        createCheckride: '68353196003ce316162a',
        emailCheckride: '686e943c003875502ce0'
    }
};